import React from 'react';
import {Box} from '@chakra-ui/react';
import HeroSvg from '../../../assets/images/build-the-future.png';
import Container from "../../../components/Container";

const HomeHero = () => {
    return (
        <>
            <Box
                pt={['59px', '59px']}
                pb={['20px', '60px']}
                borderX={'1px'}
                borderColor={'brandAlpha.200'}
            >
                <Container>
                    <Box position={'relative'} display={'flex'} justifyContent={'center'}>
                        <img src={HeroSvg} alt="companies-hero"/>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default HomeHero;
